<template>
  <div class="col-md-12">
    <form name="newDocument" @submit.prevent="handleSubmit()">
      <div class="modal-body">
        <label>Company</label>
        <input name="Company" v-model="encodingData.Company" class="form-control" />
        <label>Type :</label>

        <input name="Type" v-model="encodingData.Type" class="form-control" />

        <label>Account Number :</label>

        <input name="AccountNo" v-model="encodingData.AccountNo" class="form-control" />

        <label>Comments :</label>

        <textarea
          name="Comments"
          v-model="encodingData.Comments"
          rows="5"
          cols="5"
          class="form-control"
        />

        <label>Country:</label>

        <select name="Country" v-model="encodingData.Country" class="form-control">
          <option value>Select Country</option>
          <option
            v-for="option in countries"
            v-bind:value="option.countryName"
            v-bind:key="option.countryName"
          >{{option.countryName}}</option>
        </select>

        <label>State:</label>

        <select name="SourceId" v-model="encodingData.State" class="form-control">
          <option value>Select State</option>
          <option
            v-for="option in provinces"
            v-bind:value="option.province"
            v-bind:key="option.province"
          >{{option.province}}</option>
        </select>

        <label>City :</label>

        <input type="text" name="City" v-model="encodingData.City" class="form-control" />
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary">Update</button>
      </div>
    </form>
  </div>
</template>

<script>

import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  DataURL,
  getlocalstorageCountry,
  getlocalstorageProvince
} from '../../helper'
import instance from '../../helper/http'
export default {
  data() {
    return {
      encodingData: {
        FinancialId: '',
        Company: '',
        Type: '',
        AccountNo: '',
        Comments: '',
        Country: '',
        State: '',
        City: ''
      },
      countries: [],
      provinces: []
    }
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  created: function() {
    this.getlibs()
  },
  methods: {
    getlibs() {
      
      this.countries = getlocalstorageCountry()
      this.provinces = getlocalstorageProvince()
      this.getFinancial()
    },
    handleSubmit() {
      let loader = this.$loading.show()
      instance
        .post(EncodeURL + 'updatefinancial', this.encodingData, {
          headers: authHeader()
        })
        .then(response => {
          if (response.data.error) {
            loader.hide()
            notifyHelper('error', response.data.message)
          } else {
            loader.hide()
            notifyHelper('success', response.data.message)
            this.$emit('done-edit-financial')
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        })
    },
    getFinancial() {
      
      instance
        .get(DataURL + 'financial?financialID=' + this.id, {
          headers: authHeader()
        })
        .then(response => {
          if (response.data.error === false) {
            if (response.data.withdata) {
              let data = response.data.data
              this.encodingData.FinancialId = data.financialId
              this.encodingData.Company = data.company
              this.encodingData.Type = data.type
              this.encodingData.AccountNo = data.accountNo
              this.encodingData.Comments = data.comments
              this.encodingData.Country = data.country
              this.encodingData.State = data.state
              this.encodingData.City = data.city
            }
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        })
    }
  }
}
</script>
